import { Card, Container, Grid } from '@mui/material';
import fetch from 'isomorphic-fetch';
import { GetStaticProps } from 'next';
import React, { FC, useCallback } from 'react';
import { P, match } from 'ts-pattern';
import { makeStyles } from 'tss-react/mui';

import AuthForm, { FormValues } from '@/components/forms/auth';
import { useURLQuery } from '@/hooks/use-url-query';
import { LoginForm } from '@/types/ui-auth-rust-types';

const useStyles = makeStyles()((theme) => ({
  fillHeight: {
    height: '100%',
  },
  gridItem: {
    [theme.breakpoints.down('xs')]: {
      height: '100%',
      width: '100%',
    },
  },
}));

const Login: FC = () => {
  const { clientId, authorizationCode, email } = useURLQuery();

  const submitForm = useCallback(async ({ email, ...form }: FormValues) => {
    if (!clientId || !authorizationCode) {
      return;
    }

    // @ts-ignore - fixed with typeshare 1.7.0
    const loginForm: LoginForm = {
      clientId,
      authorizationCode,
      username: email,
      ...form,
    };

    const method = match(loginForm)
      .with({ username: P.string, password: P.string }, () => 'POST')
      .otherwise(() => 'PUT');

    const encodedForm = Object.entries(loginForm)
      .map((entries) => entries.map(encodeURIComponent).join('='))
      .join('&');

    const response = await fetch(`${window.location.origin}${window.location.pathname}`, {
      method,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: encodedForm,
      credentials: 'same-origin',
    });

    return {
      status: response.status,
      response: await response.json().catch(() => null),
    };
  }, []);

  const { classes } = useStyles();

  if (!clientId || !authorizationCode) {
    // Should've been caught by Lambda@Edge
    return null;
  }

  return (
    <Container maxWidth="xs" className={classes.fillHeight}>
      <Grid container alignItems="center" justifyContent="center" className={classes.fillHeight}>
        <Grid item xs={12} className={classes.gridItem}>
          <Card>
            <AuthForm email={email} onSubmit={submitForm} />
          </Card>
        </Grid>
      </Grid>
    </Container>
  );
};

export const getStaticProps: GetStaticProps = async () => {
  return {
    props: {
      namespaces: ['shared'],
    },
  };
};

export default Login;
